export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 256;

export const PASSWORD_REQUIREMENTS_HINT = `Use ${PASSWORD_MIN_LENGTH} or more characters with an uppercase letter, a lowercase letter, a number and a keyboard symbol, like ! @ # $ %.`;

const SYMBOL_PATTERN = /[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/;
const EDGE_WHITESPACE_PATTERN = /^\s|\s$/;

export const validatePassword = (password: string, passwordConfirmation: string) => {
  if (password && passwordConfirmation && password !== passwordConfirmation) {
    return 'err.password.not_matches';
  } else if (password?.length < PASSWORD_MIN_LENGTH) {
    return 'err.password.to_small';
  } else if (password?.length > PASSWORD_MAX_LENGTH) {
    return 'err.password.to_large';
  } else if (EDGE_WHITESPACE_PATTERN.test(password)) {
    return 'err.password.edge_space';
  } else if (password?.search(/[0-9]/) === -1) {
    return 'err.password.no_num';
  } else if (password?.search(/[a-zA-Z]/) === -1) {
    return 'err.password.no_letter';
  } else if (password?.search(/[A-Z]/) === -1) {
    return 'err.password.no_uppercase';
  } else if (password?.search(/[a-z]/) === -1) {
    return 'err.password.no_lowercase';
  } else if (!SYMBOL_PATTERN.test(password) && !password.includes(' ')) {
    return 'err.password.no_symbol';
  }
  return '';
};
